import { createFeatureSelector } from "@ngrx/store";
import { BaseState } from ".";

export const selectAppState = (state: BaseState) => state

